/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrderMessages200ResponseInner
 */
export interface GetOrderMessages200ResponseInner {
    /**
     * 送信日時
     * @type {string}
     * @memberof GetOrderMessages200ResponseInner
     */
    messageDate?: string;
    /**
     * 送信元コード (1:利用者, 2:ドライバー)
     * @type {number}
     * @memberof GetOrderMessages200ResponseInner
     */
    destCode?: number;
    /**
     * メッセージ本文
     * @type {string}
     * @memberof GetOrderMessages200ResponseInner
     */
    messageText?: string;
}

/**
 * Check if a given object implements the GetOrderMessages200ResponseInner interface.
 */
export function instanceOfGetOrderMessages200ResponseInner(value: object): value is GetOrderMessages200ResponseInner {
    return true;
}

export function GetOrderMessages200ResponseInnerFromJSON(json: any): GetOrderMessages200ResponseInner {
    return GetOrderMessages200ResponseInnerFromJSONTyped(json, false);
}

export function GetOrderMessages200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderMessages200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'messageDate': json['message_date'] == null ? undefined : json['message_date'],
        'destCode': json['dest_code'] == null ? undefined : json['dest_code'],
        'messageText': json['message_text'] == null ? undefined : json['message_text'],
    };
}

export function GetOrderMessages200ResponseInnerToJSON(json: any): GetOrderMessages200ResponseInner {
    return GetOrderMessages200ResponseInnerToJSONTyped(json, false);
}

export function GetOrderMessages200ResponseInnerToJSONTyped(value?: GetOrderMessages200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message_date': value['messageDate'],
        'dest_code': value['destCode'],
        'message_text': value['messageText'],
    };
}

